<template>
	<div class="native-landing-screen" :class="{ 'has-shortcuts-drawer': showDrawerSpacer }">
		<announcement-boxes-container :announcements="announcements"/>
		<div class="content-wrap">
			<div class="inner">
				<app-logo/>
				<div class="text-actions">
					<div class="text">
						<h2>{{ greeting }}</h2>
						<p>{{ $t('auth.login_text') }}</p>
					</div>
					<div class="actions" v-if="!userDefaultId">
						<button type="button" class="button style-4" @click="openLoginPopup">
							<span class="inner">{{ $t('auth.login') }}</span>
						</button>
						<button type="button" class="button style-1" :class="registrationLoading ? 'loading' : ''" @click="openRegistrationPopup">
							<span class="inner">{{ $t('auth.create_account') }}</span>
						</button>
					</div>
					<div class="actions" v-else>
						<button type="button" class="button style-4" :class="loading ? 'loading': ''"
						        @click="loginNative" v-if="hasNativeAuth && !pinCanceled">
							<span class="inner">{{ $t('auth.login') }}</span>
						</button>
						<button type="button" class="button style-4" @click="openLoginPopup" v-else>
							<span class="inner">{{ $t('auth.login') }}</span>
						</button>
					</div>
				</div>
			</div>
		</div>
		<native-shortcuts-drawer v-if="userDefaultId"/>
		<pin-login-popup :device-id="pinCredentials" v-if="$store.state.popups.showPinLoginPopup"/>
	</div>
</template>

<script>
import AppLogo from "../partials/AppLogo";
import { NativeBiometric } from 'capacitor-native-biometric';
import { Storage } from '@capacitor/storage';
import PinLoginPopup from "@/components/popups/PinLoginPopup";
import NativeShortcutsDrawer from "./NativeShortcutsDrawer";
import AnnouncementBoxesContainer from "./AnnouncementBoxesContainer";
import { App, URLOpenListenerEvent } from '@capacitor/app';

let launchUrlHandled = false;

export default {
	name: "NativeLandingScreen",
	components: {
		AppLogo,
		PinLoginPopup,
		NativeShortcutsDrawer,
		AnnouncementBoxesContainer,
	},
	data() {
		return {
			biometricCanceled: false,
			pinCanceled: false,
			biometricCredentials: null,
			pinCredentials: null,
			hasNativeAuth: false,
			loading: false,
			registrationLoading: false,
			urlOpenListener: null,
		}
	},
	computed: {
		announcements() {
			return this.$store.state.views.announcements;
		},
		greeting() {
			let hours = new Date().getHours();
			if (hours <= 7 && hours > 4) {
				return this.$t('greetings.morning');
			} else if (hours <= 16) {
				return this.$t('greetings.day');
			} else {
				return this.$t('greetings.evening');
			}
		},
		userDefaultId() {
			return this.$store.state.auth.userDefaultId;
		},
		showDrawerSpacer() {
			return !!this.userDefaultId && this.$store.state.views.offlineCards.length > 0;
		},

		async pinAuth() {
			const pinAuth = await Storage.get({
				key: 'user_pin'
			});

			if (pinAuth && pinAuth.value) {
				this.pinCredentials = pinAuth.value;
				return true;
			}

			return false;
		},
	},
	methods: {
		async checkNativeAuth() {
			const pin = await this.pinAuth;
			if ((this.biometricCredentials) || (pin && this.pinCredentials)) {
				this.hasNativeAuth = true;
				return true;
			}

			return false;
		},
		openLoginPopup() {
			this.$store.dispatch('openLoginPopup');
		},
		openRegistrationPopup() {
			this.registrationLoading = true;

			this.$store.dispatch('openRegistrationPopup').finally(() => {
				this.registrationLoading = false;
			});
		},
		async loginNative() {
			if (this.biometricCredentials) {
				this.loginBiometrically();
				return true;
			}

			if (this.pinCredentials) {
				this.$store.dispatch('openPinLoginPopup');
				return true;
			}

			return false;
		},
		loginBiometrically() {
			NativeBiometric.verifyIdentity({
				reason: this.$t('auth.biometric_log_in'),
				//title: "Log in",
				//subtitle: "Maybe add subtitle here?",
				//description: "Maybe a description too?",
			}).then(() => {
				this.loading = true;

				let formData = new FormData();
				formData.append('device_id', this.biometricCredentials.username);
				formData.append('hash', this.biometricCredentials.password);
				formData.append('type', 'biometric');

				const afterLoginAction = this.$store.state.auth.afterLoginAction;
				if (afterLoginAction) {
					formData.append('after_login_action', afterLoginAction);
				}

				this.$store.dispatch('nativeLogin', formData).catch((error) => {
					this.loading = false;
					this.cancelBiometricLogin();
				});
			}).catch(() => {
				this.cancelBiometricLogin();
			});
		},
		cancelBiometricLogin() {
			this.biometricCanceled = true;
			if (this.pinCredentials) {
				this.$store.dispatch('openPinLoginPopup');
			} else {
				this.openLoginPopup();
			}
		},
		loginWithPassword() {
			this.pinCanceled = true;
			this.openLoginPopup();
		},
		async handleDeepLinkUrl(urlString) {
			if (this.$store.state.auth.isLoggedIn) { return; }
			const url = new URL(urlString);
			const afterLoginAction = url.searchParams.get('after-login-action');
			if (afterLoginAction) {
				if (url.searchParams.get('platform') === 'web') {
					this.$swal.fire({ icon: 'error', title: 'Oops', text: this.$t('auth.link_web_only') });
					return;
				}
				this.$store.commit('SET_AFTER_LOGIN_ACTION', afterLoginAction);
			}
			const invite = url.searchParams.get('invite');
			if (invite) {
				this.axios.post('/api/invite-user', { hash: invite }).then(response => {
					this.$store.commit('SET_INVITE_HASH', invite);
					this.$store.commit('SET_INTRANET_USER', response.data.intranet_user);
		
					if (response.data.already_registered) {
						if (this.hasNativeAuth) {
							this.loginNative();
						} else {
							this.$store.dispatch('openLoginPopup');
						}
					} else {
						this.$store.dispatch('openRegistrationPopup');
					}
				});
				return;
			}
			const agent = url.searchParams.get('agent');
			if (agent) {
				this.$store.commit('SET_INVITE_AGENT', agent);
				this.$store.dispatch('openRegistrationPopup');
				return;
			}
			if (afterLoginAction) {
				if (this.hasNativeAuth) {
					this.loginNative();
				} else {
					this.$store.dispatch('openLoginPopup');
				}
			}
		},
		async checkBiometricAuth() {
			if (this.biometricCanceled) {
				return false;
			}

			let userId = this.userDefaultId;
			if (!userId) {
				const stored = await Storage.get({ key: 'default_user_id' });
				userId = stored.value;
			}

			if (!userId) {
				return false;
			}

			let availableBiometric = await NativeBiometric.isAvailable();
			if (!availableBiometric.isAvailable) {
				return false;
			}

			try {
				this.biometricCredentials = await NativeBiometric.getCredentials({
					server: process.env.VUE_APP_CAP_ID_ANDROID,
				});
				return true;
			} catch (error) {
				return false;
			}
		},
	},
	async mounted() {
		this.$store.dispatch('closePopups');
		this.$root.$on('login-with-password', this.loginWithPassword);
		this.loading = false;

		await this.$nextTick();
		await this.checkBiometricAuth();
		await this.checkNativeAuth();

		if (!launchUrlHandled) {
			const launchUrl = await App.getLaunchUrl();
			if (launchUrl && launchUrl.url) {
				launchUrlHandled = true;
				await this.handleDeepLinkUrl(launchUrl.url);
			}
		}

		this.urlOpenListener = await App.addListener('appUrlOpen', (data) => {
			this.handleDeepLinkUrl(data.url);
		});
	},
	async updated() {
		await this.checkBiometricAuth();
		await this.checkNativeAuth();
	},
	destroyed() {
		if (this.urlOpenListener) {
			this.urlOpenListener.remove();
		}
	}
}
</script>

<style scoped lang="scss">
.native-landing-screen {
	.announcement-boxes-container {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 200;
		padding: calc(var(--safe-area-top, 0px) + 12px) 15px 0;
		pointer-events: none;
	}

	.content-wrap {
		> .inner {
			padding: 40px 0;
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			flex-direction: column;
			min-height: 100vh;
		}
	}

	&.has-shortcuts-drawer {
		.content-wrap > .inner {
			padding-bottom: calc(40px + 80px + var(--safe-area-bottom, 0px) / 2);
		}
	}

	.logo {
		max-width: 144px;
		margin-top: auto;
		margin-bottom: 35px;
	}

	@media($mobileS) {
		.logo {
			max-width: 100px;
		}
	}
}

.text-actions {
	margin-top: auto;
	width: 100%;
}

.text {
	color: var(--white-color, $whiteColor);
	margin-bottom: 50px;

	&:last-child {
		margin-bottom: 0;
	}

	h2 {
		margin-bottom: 15px;
	}

	p {
		font-weight: 700;
		font-size: 15px;
	}
}

.actions {
	.button {
		width: 100%;
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}
}
</style>